"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.axiosInstance = void 0;
/* eslint-disable import/prefer-default-export */
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("~/utils/utils");
const projectSharing_1 = require("~/utils/projectSharing");
const axiosConfig = {
    baseURL: `${process.env.API_HOSTNAME}/api`, // API_DOMAIN
};
const requestHandler = (request) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const token = (0, utils_1.getToken)();
    const refreshToken = (0, utils_1.getRefreshToken)();
    request.headers = (_a = request.headers) !== null && _a !== void 0 ? _a : {};
    if (token) {
        request.headers['x-access-token'] = token;
    }
    if (refreshToken) {
        request.headers['x-refresh-token'] = refreshToken;
    }
    const match = (_b = request.url) === null || _b === void 0 ? void 0 : _b.match(/^\/projects\/(\d+)(?:\/|$)/);
    const itemProperties = (_c = request.url) === null || _c === void 0 ? void 0 : _c.startsWith('/data/item-properties/');
    const pageProjectId = itemProperties ? (_d = window.location.pathname.match(/^\/projects\/(\d+)$/)) === null || _d === void 0 ? void 0 : _d[1] : undefined;
    const projectId = match
        ? Number(match[1])
        : Number((_f = pageProjectId !== null && pageProjectId !== void 0 ? pageProjectId : (_e = request.data) === null || _e === void 0 ? void 0 : _e.projectId) !== null && _f !== void 0 ? _f : (_j = (_h = (_g = request.data) === null || _g === void 0 ? void 0 : _g.createItems) === null || _h === void 0 ? void 0 : _h[0]) === null || _j === void 0 ? void 0 : _j.projectId);
    const shareToken = (0, projectSharing_1.getProjectShareToken)(projectId);
    if (shareToken && (match || itemProperties || ((_k = request.url) === null || _k === void 0 ? void 0 : _k.startsWith('/quote')))) {
        request.headers['x-project-share-token'] = shareToken;
    }
    return request;
};
exports.axiosInstance = axios_1.default.create(axiosConfig);
exports.axiosInstance.interceptors.request.use((request) => requestHandler(request));
